import { useTranslation } from 'react-i18next';

export function LoadingFallback() {
  const { t } = useTranslation('common');
  return (
    <div className="flex items-center justify-center p-12 text-muted-foreground">
      {t('loading', 'Chargement…')}
    </div>
  );
}
